import { Link } from 'react-router-dom';
import PolicyLayout from '../components/PolicyLayout';
import { COMPANY_NAME, SITE_DOMAIN } from '../constants/site';

export default function CookiePolicy() {
  return (
    <PolicyLayout title="Cookie Policy" intro={`How ${SITE_DOMAIN} uses cookies and similar technologies.`}>
      <h2>1. What are cookies?</h2>
      <p>
        Cookies are small text files stored on your device when you visit a website. They help the site
        work, remember your preferences, and understand how it is used.
      </p>

      <h2>2. Cookies we use</h2>
      <ul>
        <li>
          <strong>Essential cookies:</strong> needed for the website to function and stay secure.
        </li>
        <li>
          <strong>Live chat cookies:</strong> set by our chat provider, Zoho SalesIQ, so your chat
          conversation continues as you move between pages.
        </li>
        <li>
          <strong>Analytics cookies:</strong> help us understand which pages are useful so we can improve
          them. This information is aggregated.
        </li>
      </ul>

      <h2>3. Managing cookies</h2>
      <p>
        You can block or delete cookies through your browser settings. If you block essential or chat
        cookies, some features, such as live chat, may not work properly.
      </p>

      <h2>4. More information</h2>
      <p>
        For details on how {COMPANY_NAME} handles personal information, see our{' '}
        <Link to="/privacy-policy">Privacy Policy</Link>.
      </p>
    </PolicyLayout>
  );
}
